export const WEATHER_FADE_MS = 900;

export function advanceWeatherFade(current: number, enabled: boolean, elapsedMs: number): number {
  const bounded = Math.max(0, Math.min(1, current));
  const step = Math.max(0, elapsedMs) / WEATHER_FADE_MS;
  return enabled ? Math.min(1, bounded + step) : Math.max(0, bounded - step);
}

export function weatherFadePhase(value: number, enabled: boolean): "fading-in" | "fading-out" | "visible" | "hidden" {
  if (enabled) return value >= 0.999 ? "visible" : "fading-in";
  return value <= 0.001 ? "hidden" : "fading-out";
}
